import useEmblaCarousel from 'embla-carousel-react';
import {useCallback, useEffect, useState} from 'react';
// import {ProductWithNodes} from '../../../types';
import styles from './embla.module.scss';
import clsx from 'clsx';
// import ProductCard from '../../product/card/ProductCard.client';

type Props = {
  products: any;
  direction: 'rtl' | 'ltr';
};

export default function CollectionCarousel({products, direction = 'rtl'}: Props) {
  const [selectedIndex, setSelectedIndex] = useState(0);
 

  

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
    breakpoints: {
      '(min-width: 768px)': {direction: direction},
    },
  });

  const onScroll = useCallback(() => {
    if (!emblaApi) return;
  
  
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi],
  );
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi],
  );

  

 

  useEffect(() => {
    if (!emblaApi) return;
    onScroll();
    onSelect();
    emblaApi.on('scroll', onScroll);
    emblaApi.on('select', onSelect);
  }, [emblaApi, onScroll, onSelect]);

  return (
    <div className='bg-green relative'>

   
    <div
      className={clsx(
        direction == 'ltr' ? styles.ltr : '',
        direction == 'rtl' ? styles.rtl : '',
        styles.carousel,
        ' overflow-hidden',
      )}
      ref={emblaRef}
    >
      <div className="flex gap-1">
        {products.map((product: any, i: number) => {
          return (
            <div
              key={i}
              className={'flex-shrink-0 flex-grow-0'}
            >
                {product}
            
            </div>
          );
        })}
      </div>

      <div className={clsx(styles.arrow, styles.prev)}>
        <button
          onClick={scrollPrev}
          className={clsx(
            selectedIndex == products.length - 1 ? styles.last : '',
            'flex items-center justify-center  focus:outline-none ',
          )}
          disabled={selectedIndex == products.length - 1}
        >
          <svg
            width="22"
            height="42"
            viewBox="0 0 34 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-2"
          >
            <path
              d="M33.9906 32.2516C33.9313 31.4469 33.5987 30.6834 33.0432 30.085L6.44323 1.19793C5.78743 0.484745 4.87037 0.0552881 3.89129 0.00499142C2.91222 -0.0453053 1.95293 0.286137 1.22456 0.925808C0.494876 1.56677 0.0567985 2.46437 0.00533764 3.42001C-0.0461232 4.37694 0.292991 5.31452 0.947468 6.02641L25.332 32.4992L0.947468 58.9734C0.292991 59.6853 -0.0474427 60.6241 0.00533764 61.5798C0.0567985 62.5367 0.494876 63.4343 1.22456 64.074C1.95293 64.7136 2.91354 65.0464 3.89129 64.9948C4.86905 64.9445 5.78743 64.515 6.44323 63.8031L33.0445 34.9148C33.7162 34.1887 34.0579 33.2279 33.9919 32.2516H33.9906Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
      <div className={styles.arrow}>
        <button
          onClick={scrollNext}
          className={clsx(
            selectedIndex == products.length - 1 ? styles.last : '',
            'flex items-center justify-center  focus:outline-none ',
          )}
          disabled={selectedIndex == products.length - 1}
        >
          <svg
           width="22"
           height="42"
            viewBox="0 0 34 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-2"
          >
            <path
              d="M33.9906 32.2516C33.9313 31.4469 33.5987 30.6834 33.0432 30.085L6.44323 1.19793C5.78743 0.484745 4.87037 0.0552881 3.89129 0.00499142C2.91222 -0.0453053 1.95293 0.286137 1.22456 0.925808C0.494876 1.56677 0.0567985 2.46437 0.00533764 3.42001C-0.0461232 4.37694 0.292991 5.31452 0.947468 6.02641L25.332 32.4992L0.947468 58.9734C0.292991 59.6853 -0.0474427 60.6241 0.00533764 61.5798C0.0567985 62.5367 0.494876 63.4343 1.22456 64.074C1.95293 64.7136 2.91354 65.0464 3.89129 64.9948C4.86905 64.9445 5.78743 64.515 6.44323 63.8031L33.0445 34.9148C33.7162 34.1887 34.0579 33.2279 33.9919 32.2516H33.9906Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
    
    </div>

    </div>

    
  );
}
